import "./setting.scss";

import { Menubar } from "primereact/menubar";
import { BsGiftFill } from "react-icons/bs";
import { FaVrCardboard } from "react-icons/fa6";
import { GiStairs } from "react-icons/gi";
import { Outlet, useNavigate } from "react-router-dom";

export function Setting() {
  const navigate = useNavigate();
  const items = [
    {
      label: "Reward",
      icon: <BsGiftFill className="block mr-2" />,
      command: () => navigate(``),
    },
    {
      label: "Level",
      icon: <GiStairs className="block mr-2" />,
      command: () => navigate(`level`),
    },
    {
      label: "Card Category",
      icon: <FaVrCardboard className="block mr-2" />,
      command: () => navigate(`card-category`),
    },
  ];
  return (
    <div id="Setting" className="setting">
      <div className="bg-white py-7 px-4">
        <Menubar
          className="bg-white p-4"
          model={items}
          start={<h1 className="mr-4">Settings</h1>}
        />
      </div>

      <div className="p-7">
        <Outlet />
      </div>
    </div>
  );
}

export default Setting;
